import type { ThemePreference } from '../settings.interface'

const STORAGE_KEY = 'themePreference:v1'
const DEFAULT_THEME: ThemePreference = 'system'

export const resolveThemePreference = {
  load(): ThemePreference {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored === 'system' || stored === 'light' || stored === 'dark') {
        return stored
      }
      return DEFAULT_THEME
    } catch {
      return DEFAULT_THEME
    }
  },

  save(theme: ThemePreference): void {
    try {
      localStorage.setItem(STORAGE_KEY, theme)
    } catch {
      // localStorage unavailable (incognito, quota exceeded)
    }
  },
}
